import { CurrentOrganization } from '@core/organization';
var lastSeenProject = 'lastSeenProject';
var getProjectId = function getProjectId() {
    var _localStorage_getItem;
    var orgId = CurrentOrganization.getId();
    return (_localStorage_getItem = localStorage.getItem("".concat(lastSeenProject, "_").concat(orgId))) !== null && _localStorage_getItem !== void 0 ? _localStorage_getItem : null;
};
var setProjectId = function setProjectId(projectId) {
    var orgId = CurrentOrganization.getId();
    localStorage.setItem("".concat(lastSeenProject, "_").concat(orgId), projectId);
};
export var ProjectLocalStorage = {
    getProjectId: getProjectId,
    setProjectId: setProjectId
};

//# sourceMappingURL=ProjectLocalStorage.js.map